import { Button, Form, Select } from "antd";
import { ApplicationInfoItem } from "../../../../Ui/Application/ApplicationInfoFieldItem/ApplicationInfoFieldItem";
import classes from "../ExternalBankContent.module.css";
import { useAppSelector } from "../../../../../store/reduxHooks";
import { ApplicationCreditWorkerUploadDoc } from "../../../../Ui/Application/ApplicationDownloadFileComponents/ApplicationCreditWorkerUploadDoc/ApplicationCreditWorkerUploadDoc";
import { useCommisionFields } from "../hooks/useCommisionFIelds";
import { useOptionsBankStatuses } from "../hooks/useOptionsBankStatuses";
import { useChangeApplicationStatus } from "../hooks/useChangeApplicationStatus";
import {
  useSetDocumentToBankMutation,
  useUpdateDocumentToBankMutation,
} from "../../../../../store/api/application.api";
import { validateFile } from "../../../../../utils/utilities/validateFile";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { DownloadingFiles } from "../../../../../utils/utilities/Downloads";
import { useCallback } from "react";
import { IDownloadDocumentHandlerProps } from "../../../../../interfaces/props/IDownloadDocumentHandlerProps";

export const ExternalBankUploadDocs = () => {
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );

  const documents = activeBankInfo.documents;

  const applicationId = activeBankInfo.application_id;

  const bank_id = activeBankInfo.bank_id;

  const commisionFields = useCommisionFields();

  const selectOptionsBankStatuses = useOptionsBankStatuses();

  const { handleSubmitForm, isLoadingEditBank } = useChangeApplicationStatus();

  const [
    setDocumentToBank,
    { isLoading: isSetDocumentLoading, originalArgs: setDocumentArgs },
  ] = useSetDocumentToBankMutation();
  const [
    updateDocumentToBank,
    { isLoading: isUpdateDocumentLoading, originalArgs: updateDocumentArgs },
  ] = useUpdateDocumentToBankMutation();

  const downloadDocument = useCallback(
    ({ name, document_id }: IDownloadDocumentHandlerProps) => {
      if (name && document_id) {
        const urlFile = {
          url: "auth/file/" + document_id,
          fileName: `${name}`,
        };
        DownloadingFiles(urlFile);
      }
    },
    [],
  );
  
  // TODO: функция потом будет дорабатываться
  const uploadDocument = (options: UploadRequestOption, index: number) => {
    const { file } = options;

    const { isValidate } = validateFile(file as File);
    const typeDocId = documents[index]?.id;

    if (isValidate) {
      if (documents[index].document) {
        // Если файл в документе уже есть

        updateDocumentToBank({
          documents,
          index,
          applicationId,
          typeDocId,
          file,
          bank_id,
        });
      } else {
        // Если файла в документ не добавили

        setDocumentToBank({
          applicationId,
          typeDocId,
          file,
          bank_id,
        });
      }
    } else {
    }
  };

  return (
    <>
      <Form
        key={activeBankInfo.bank_id}
        onFinish={handleSubmitForm}
        layout="vertical"
        className={classes.form}
      >
        <div className={classes.infoContainer}>
          {commisionFields.map((el) => {
            return (
              <ApplicationInfoItem
                key={el.name}
                value={el.value}
                label={el.name}
              />
            );
          })}

          <ApplicationInfoItem
            label="Номер заявки"
            value={activeBankInfo.bank_id}
          />

          <Form.Item
            name={"status_id"}
            layout="vertical"
            label={<span className={classes.formItemLabel}>Статус</span>}
          >
            <Select
              defaultValue={activeBankInfo.status_id}
              value={activeBankInfo.status_id}
              options={selectOptionsBankStatuses}
            />
          </Form.Item>
        </div>

        <div className={classes.submitFormContainer}>
          <Button
            size="middle"
            disabled={isLoadingEditBank}
            loading={isLoadingEditBank}
            htmlType="submit"
            color="primary"
            variant="solid"
            className={classes.submitBtn}
          >
            Сохранить изменения
          </Button>
        </div>
      </Form>

      <div className={classes.headerDocs}>Документы от банка</div>

      <div className={classes.docList}>
        {documents.map((el, index) => {
          return (
            <ApplicationCreditWorkerUploadDoc
              onDownloadClick={() => {
                if (el.document && el.document?.name && el.document.id) {
                  downloadDocument({
                    name: el.document.name,
                    document_id: el.document.id,
                  });
                }
              }}
              onUpload={(options) => {
                uploadDocument(options, index);
              }}
              className={classes.docItem}
              docSigned={!!el.document?.sign_file?.length}
              title={el.name}
              key={el.id}
              subtitle={
                el.document?.name ? el.document.name : "Загрузите документ"
              }
            />
          );
        })}
      </div>
    </>
  );
};
